import React, { useState } from 'react';
import { Icon } from 'semantic-ui-react';

const ModelBrandIconV10 = ({ brand, small = false }) => {
  const [failedIcon, setFailedIcon] = useState(null);
  const iconFile = brand?.icon
    ? `${brand.icon}.${brand.format || 'svg'}`
    : null;
  return (
    <span
      className={`model-brand-icon-v10${
        small ? ' model-brand-icon-small-v10' : ''
      }`}
      data-monochrome={Boolean(brand?.monochrome)}
      title={brand?.name}
      aria-hidden='true'
    >
      {iconFile && failedIcon !== iconFile ? (
        <img
          src={`${process.env.PUBLIC_URL || ''}/model-icons/${iconFile}`}
          alt=''
          width={small ? 18 : 30}
          height={small ? 18 : 30}
          draggable='false'
          onError={() => setFailedIcon(iconFile)}
        />
      ) : (
        <Icon name='cube' />
      )}
    </span>
  );
};

export default ModelBrandIconV10;
